import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, UpsertAmphoraIntegration } from "schema"
import { z } from "zod"
import { amphoraIntegrationQuery } from "../../lib/amphora/amphoraIntegrationQuery"

type Response = DataResponse<z.infer<typeof UpsertAmphoraIntegration>>

export function useCreateAmphoraIntegrationConfigurationMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.infer<typeof UpsertAmphoraIntegration>) => {
      const response = await axios.post<Response>(`/integrations/amphora`, data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: amphoraIntegrationQuery().queryKey })
    },
  })
}
